<template>
    <div class="th-dropdown-hover th-dropdown th-dropdown-end">
        <label tabindex="0" class="mb-2 cursor-pointer">+{{counts}}</label>
        <div tabindex="0" class="th-dropdown-content th-menu w-64 p-2">
            <div v-for="(item, index) in orgs" :key="index" class="flex items-center gap-1 py-1">
                <SolutionOrgIcon class="shrink-0 h-4 w-4" :org-info-logo="item.logo" />
                <a v-if="item.id" :href="generateCompanyHref(item.id)" target="blank" class="hover:underline hover:cursor-pointer truncate">
                    <span class="truncate" :title="item.display_name" v-html="item.display_name"></span>
                </a>
                <span v-else class="truncate" :title="item.display_name" v-html="item.display_name"></span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { IOrgInfo } from './types';
import SolutionOrgIcon from './SolutionOrgIcon.vue'
import { generateCompanyHref } from '@eureka/utils/company'

defineProps<{
    orgs?: IOrgInfo[],
    counts?:number
}>()
</script>
